import { useEffect, useRef, useState } from 'react';

export const useIsVisible = (ref: HTMLDivElement | HTMLElement | null) => {
    const observer = useRef<IntersectionObserver>();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (!ref) {
            return;
        }

        if (!observer.current) {
            observer.current = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
                setIsVisible(Boolean(entries.find((item) => item.isIntersecting && item.target === ref)));
            });
        }

        observer.current.observe(ref);

        return () => {
            if (observer.current) {
                observer.current.unobserve(ref);
            }
        };
    }, [ref]);

    return isVisible;
};
